export const communication = {
        title: "Informations",
        action: {
            label: "J'ai compris",
            title: "Vous indiquez avoir compris"
        },
}